import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
import type { ItemSoldPerMonthEntry } from "../../types/market";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const options = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    x: {
      ticks: { color: "rgb(199, 238, 255)" },
      grid: { color: "rgb(70, 130, 180)" }
    },
    y: {
      beginAtZero: true,
      ticks: { color: "rgb(199, 238, 255)", precision: 0 },
      grid: { color: "rgb(70, 130, 180)" }
    }
  },
  plugins: {
    legend: { display: false }
  }
};

type Props = {
  entries: ItemSoldPerMonthEntry[];
};

const SoldPerMonthChart = ({ entries }: Props) => (
  <Bar
    options={options}
    data={{
      labels: entries.map(e => e.month),
      datasets: [
        {
          label: "Sold",
          data: entries.map(e => e.count),
          borderColor: "#796dce",
          backgroundColor: "#393e6f"
        }
      ]
    }}
  />
);

export default SoldPerMonthChart;
